export enum RFSCustomType {
  Standard = 0,
  DSV = 1,
  Tryg = 2,
  SevenN = 3,
}
